import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4976c298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 mx-3" }
const _hoisted_2 = {
  key: 0,
  class: "caution-area mb-4"
}
const _hoisted_3 = { class: "d-flex align-items-center caution" }
const _hoisted_4 = { class: "ml-1" }
const _hoisted_5 = {
  key: 0,
  class: "caution"
}
const _hoisted_6 = {
  key: 1,
  class: "caution"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_RejectionReason = _resolveComponent("RejectionReason")!
  const _component_EditQualificationForm = _resolveComponent("EditQualificationForm")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["edit-qualification bg-background", { invisible: _ctx.isCameraActive }])
  }, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      資格編集\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.isRejected)
      ? (_openBlock(), _createBlock(_component_RejectionReason, {
          key: 0,
          details: _ctx.rejectionReasonDetails,
          comment: _ctx.rejectionReasonComment
        }, null, 8, ["details", "comment"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isUnverified || _ctx.isVerified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FeatherIcon, {
                icon: "info",
                size: "24"
              }),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.isUnverified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "\n              この資格は審査中です\n            "))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.isVerified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "\n              この資格は認証済みです\n            "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createTextVNode(),
            (_ctx.verifiedComment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "\n          認証時のコメント: " + _toDisplayString(_ctx.verifiedComment), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        ref: "vObserver",
        initialValues: _ctx.formValues
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_EditQualificationForm, {
            modelValue: _ctx.inputValues,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues) = $event)),
            isCameraActive: _ctx.isCameraActive,
            "onUpdate:isCameraActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCameraActive) = $event)),
            qualificationOptions: _ctx.filteredQualificationOptions,
            verifiedQualification: _ctx.verifiedQualification,
            disabledQualificationId: !_ctx.isRejected || _ctx.verifiedQualification,
            disabledImage: _ctx.isUnverified,
            disabledText: _ctx.disabledText
          }, null, 8, ["modelValue", "isCameraActive", "qualificationOptions", "verifiedQualification", "disabledQualificationId", "disabledImage", "disabledText"]),
          _createTextVNode(),
          _createVNode(_component_AppButton, {
            block: "",
            disabled: !_ctx.canReverify,
            class: "mt-4",
            onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          再認証を申請する\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createTextVNode(),
          (!_ctx.isVerified)
            ? (_openBlock(), _createBlock(_component_AppButtonOutline, {
                key: 0,
                block: "",
                variant: "red",
                class: "mt-3",
                disabled: _ctx.isSubmitting,
                onClick: _ctx.onClickDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.deleteQualificationLabel), 1)
                ], undefined, true),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["initialValues"])
    ])
  ], 2))
}